export default __webpack_public_path__ + "static/hover_measurements_report_sales-3cf1c1a9935e6cff121b06d4aa07434e.gif";